module.exports = __webpack_public_path__ + "img/ff03.3cf13e52.svg";